import type { ClaimFlowDraft } from './claimDraftStorage'

/** Clears insured-driver answers so the user must complete the driver step after legacy unattended removal. */
export function clearMultiVehicleInsuredDriverCapturePatch(): Partial<ClaimFlowDraft> {
  return {
    multiVehicleAttendedAtCollision: true,
    multiVehicleDriverCaptureMode: null,
    multiVehiclePrimaryDriverDriving: null,
    multiVehicleSecondaryOnPolicyDriving: null,
    multiVehicleListedDriverId: null,
    multiVehicleDriverFirstName: null,
    multiVehicleDriverLastName: null,
    multiVehicleDriverDobDdMmYyyy: null,
    multiVehicleDriverGender: null,
    multiVehicleLicenseNumber: null,
    multiVehicleLicenseExpiryDdMmYyyy: null,
    multiVehicleYearsLicensed: null,
  }
}

/**
 * Multi-vehicle collision no longer supports “vehicle unattended” skip. Resets legacy drafts so the
 * driver gate and FNOL narrative require insured-driver capture.
 */
export function migrateLegacyMultiVehicleUnattendedDraft(draft: ClaimFlowDraft): {
  merged: ClaimFlowDraft
  didMigrate: boolean
} {
  if (draft.otherClaimSubtypeId !== 'multi-vehicle-collision') {
    return { merged: draft, didMigrate: false }
  }
  const legacyUnattended =
    draft.multiVehicleDriverCaptureMode === 'none_unattended' ||
    draft.multiVehicleAttendedAtCollision === false
  if (!legacyUnattended) {
    return { merged: draft, didMigrate: false }
  }
  return {
    merged: { ...draft, ...clearMultiVehicleInsuredDriverCapturePatch() },
    didMigrate: true,
  }
}
